var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[(_vm.informationIds.includes(parseInt(_vm.id)))?_c('station-' + _vm.id,{tag:"component",staticClass:"station-information"}):_c('p',{staticClass:"error"},[_vm._v("Keine Detailinformationen vorhanden.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }